
import { Navigate } from 'react-router-dom';
import { auth_service } from '../../authService';

export const PrivateRoute = ({ element, pathName }) => {
    if (!auth_service.isAuthenticated()) {
        if(pathName) {
            auth_service.setRedirectionUrl(pathName);
        }
        return <Navigate to="/login" />
    }
    return element;
};

export const PublicRoute = ({ element }) => {
    return element;
};

